import Vue from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods.js';
import filters from '../../../Shared/filters.js';
import computed from '../../../Shared/computed.js';
import EventBus from '@/Application/event-bus.js';
import careHelpfulFunctions from '../../careHelpfulFunctions.jsx';
import MarkdownIt from 'markdown-it';

Vue.component('display-ask-ai', {
    data: () => ({
        vars: {},
        interactions: [],
        expanded: null,
        useTranscripts: false,
        conversationStarted: false,
        sessionid: "",
        messages: [],
        userInput: '',
        loading: false,
        showExitConfirm: false
    }),
    props: {
        name: '',
        root: null,
        type: null,
        action: null,
        context: null,
        scopeitems: null,
        controlscope: null
    },
    created() {
        if (this.action.ActionData && this.action.ActionData.Vars) {
            const varsexpn = utils.compileObject(this, this.action.ActionData.Vars);
            try {
                this.vars = utils.evaluateObject(varsexpn, this.action.context);
            } catch (e) {
                utils.log('error evaluating Vars: ' + e);
            }
        }

        if (this.action.ActionData && this.action.ActionData.Javascript) {
            try {
                const api = utils.apiWrapper;
                const chf = careHelpfulFunctions;
                this.Javascript = eval("new (" + this.action.ActionData.Javascript + ")(null, null, api, this, chf);");
                
                for (let key in this.Javascript)
                    if (typeof this.Javascript[key] === 'function')
                        this.Javascript[key] = this.Javascript[key].bind(this.Javascript);
            } catch (e) {
                utils.warn(`Failed evaluating Javascript in ${this.name}: ${this.action.ActionData.Javascript}`, e);
            }
        }

        if (this.action.ActionData && this.action.ActionData.InteractionExpression) {
            const interactionExpn = utils.compileExpression(this, this.action.ActionData.InteractionExpression);
            try {
                this.interactions = utils.evaluate(interactionExpn, this.action.context);
            }
            catch (e) {
                utils.log('error evaluating Interactions: ' + e);
            }
        }

        this.$on('Action-Close', this.performClose);
        EventBus.$on(`Action-Close:${this.name}`, this.performClose);
        EventBus.$on(`Action-Close`, this.performClose);

        this.loadInteractions();
    },
    destroyed() {
        this.$off('Action-Close', this.performClose);
        EventBus.$off(`Action-Close:${this.name}`, this.performClose);
        EventBus.$off(`Action-Close`, this.performClose);
        
        if (this.sessionid) {
            // end the chat.
            utils.api.request('GET', `/Apps/AI/Insights/AskAI/EndChat?SessionID=${this.sessionid}`);
        }
    },
    computed: {
        ...computed,
        Vars() {
            return this.vars;
        },
        interactionCount() {
            if (!this.interactions) return 0;

            return this.interactions.length;
        },
        callCount() {
            if (!this.interactions) return 0;

            return this.interactions.filter(i => i.ChannelType === 'Call' || i.timelinetype === 'Call').length;
        },
        emailCount() {
            if (!this.interactions) return 0;

            return this.interactions.filter(i => i.ChannelType === 'EMail' || i.timelinetype === 'EMail').length;
        },
        chatCount() {
            if (!this.interactions) return 0;

            return this.interactions.filter(i => i.ChannelType === 'Chat' || i.timelinetype === 'Chat').length;
        },
        otherCount() {
            if (!this.interactions) return 0;

            return this.interactions.filter(i =>
                i.ChannelType !== 'Chat'
                && i.timelinetype !== 'Chat'
                && i.ChannelType !== 'EMail'
                && i.timelinetype !== 'EMail'
                && i.ChannelType !== 'Call'
                && i.timelinetype !== 'Call'
            ).length;
        },
        queues() {
            if (!this.interactions) return [];

            return [...new Set(this.interactions.map(i => i.QueueName || i.queuename).filter(Boolean))];
        },
        analysisDisabled() {
            if (this.interactionCount <= 0)
                return true;

            if (this.useTranscripts) {
                return this.interactionCount > 30;
            } else {
                return this.interactionCount > 100;
            }
        },
        formattedDateRange() {
            if (!this.interactions || this.interactions.length === 0) return null;

            const dates = this.interactions
                .map(i => new Date(i.starttime))
                .filter(d => !isNaN(d));

            if (dates.length === 0) return null;

            const minDate = new Date(Math.min(...dates));
            const maxDate = new Date(Math.max(...dates));

            if (minDate.getTime() === maxDate.getTime()) {
                return minDate.toLocaleString();
            } 
            else if (minDate.toDateString() === maxDate.toDateString()) {
                const datePart = minDate.toLocaleDateString();
                const startTime = minDate.toLocaleTimeString();
                const endTime = maxDate.toLocaleTimeString();
                
                return `${datePart} ${startTime} - ${endTime}`;
            } 
            else {
                return `${minDate.toLocaleString()} - ${maxDate.toLocaleString()}`;
            }
        }
    },
    methods: {
        ...methods,
        ...filters,
        async loadInteractions() {
            try {
                if (this.action.ActionData.DataType === 'Raw') {
                    this.interactions = this.action.ActionData.DataRaw || [];
                } else if (this.action.ActionData.DataType === 'URL' && this.action.ActionData.DataURL) {
                    const response = await utils.apiWrapper.request('GET', this.action.ActionData.DataURL);
                    this.interactions = response || [];
                }

                if (this.interactions.length == 1) {
                    this.useTranscripts = true;
                    this.startAnalysis();
                }
            } catch (e) {
                utils.error('Failed to load interactions', e);
            }
        },
        startAnalysis() {
            if (!this.conversationStarted) {
                this.conversationStarted = true;
                this.messages = [{
                    role: 'assistant',
                    content: 'Hi! I am your virtual sidekick and I will help you analyze the interactions you have selected. Where would you like to begin?'
                }];
            }
        },
        async keyUp(e) {
            if (e.key === 'Enter' && !e.shiftKey)
                this.sendMessage()
        },
        async sendMessage() {
            if (!this.userInput.trim()) return;

            var message = this.userInput.trim();
            this.userInput = "";

            this.messages.push({
                role: 'user',
                content: message
            });
            this.loading = true;

            try {
                // Send to the Server and get results back to add to messages.
                var response = await utils.api.request('POST', `/Apps/AI/Insights/AskAI/Ask?SessionID=${this.sessionid}`, {
                    Interactions: this.interactions,
                    UseSummaries: !this.useTranscripts,
                    Message: message
                });

                if (response.Success) {
                    this.messages.push({
                        role: 'assistant',
                        content: response.Message
                    });

                    if (response.SessionID && !this.sessionid)
                        this.sessionid = response.SessionID;
                } else {
                    this.messages.push({
                        role: 'assistant',
                        content: 'Sorry, there was an error processing your request.'
                    });
                }
            } catch (e) {
                utils.error('Failed to send message', e);
                this.messages.push({
                    role: 'assistant',
                    content: 'Sorry, there was an error processing your request.'
                });
            } finally {
                this.loading = false;
            }
        },
        handleExit() {
            if (this.conversationStarted && this.messages.length > 1) {
                this.showExitConfirm = true;
            } else {
                this.finish();
            }
        },
        confirmExit() {
            this.showExitConfirm = false;
            this.finish();
        },
        finish() {
            this.$emit('closeme', {
                Success: true,
                DialogResult: {},
                AllowClose: true
            });
        },
        async export() {
            const lines = ["ID|Channel|Queue|Start Time|Role|Message"];

            for (const i of this.interactions) {
                // skip role and message for interactions included.
                lines.push(`${i.timelineid || i.sessionid || i.SessionID || ''}|${i.ChannelType || i.channeltype || i.timelinetype || ''}|${i.QueueName || i.queuename || ''}|${i.starttime || ''}||`);
            }

            // add some blank lines
            lines.push('|||||');
            lines.push('|||||');

            for (const m of this.messages) {
                // only add role and message for conversation history.
                const safeContent = `"${m.content.replace(/"/g, '""')}"`;
                lines.push(`||||${m.role}|${safeContent}`);
            }

            const blob = new Blob([lines.join('\r\n')], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `ask-ai-export-${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        },
        async performClose(action) {
            this.$emit('closeme', {
                Success: action.ActionData ? action.ActionData.Success : true,
                DialogResult: {},
                AllowClose: true
            });

            try {
                await utils.success(action);
            } catch (e) { }

            action.FinishFunc(true);
        },
        getMarkdownHtml(text) {
            const md = MarkdownIt()
            const result = md.render(text)
            
            return result;
        },
        getInteractionDetails() {
            var cols = [];

            cols.push(<v-col>
                <div class="text-caption font-weight-bold" style={{ color: 'rgba(0,0,0,0.6) !important' }}><translation-container context={this} value="Calls" /></div>
                <div style={{ fontSize: '14px' }}>{this.callCount}</div>
            </v-col>);
            
            if (this.emailCount) {
                cols.push(<v-divider vertical class="mx-2" />)
            
                cols.push(<v-col class="pl-4">
                    <div class="text-caption font-weight-bold" style={{ color: 'rgba(0,0,0,0.6) !important' }}><translation-container context={this} value="Emails" /></div>
                    <div style={{ fontSize: '14px' }}>{this.emailCount}</div>
                </v-col>);
            }
            
            if (this.chatCount) {
                cols.push(<v-divider vertical class="mx-2" />);
                
                cols.push(<v-col class="pl-4">
                    <div class="text-caption font-weight-bold" style={{ color: 'rgba(0,0,0,0.6) !important' }}><translation-container context={this} value="Chats" /></div>
                    <div style={{ fontSize: '14px' }}>{this.chatCount}</div>
                </v-col>);
            }
            
            if (this.otherCount) {
                cols.push(<v-divider vertical class="mx-2" />);
                
                cols.push(<v-col class="pl-4">
                    <div class="text-caption font-weight-bold" style={{ color: 'rgba(0,0,0,0.6) !important' }}><translation-container context={this} value="Other" /></div>
                    <div style={{ fontSize: '14px' }}>{this.otherCount}</div>
                </v-col>);
            }

            return <v-row no-gutters class="mb-4">
                {cols}
            </v-row>
        }
    },
    render(h) {
        let content;

        const expansionSection = (
            <v-expansion-panels vModel={this.expanded} flat class="mb-6 InteractionSelection">
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="flex-grow-1" style={{ color: "rgba(0,0,0,0.6", fontWeight: 700, fontSize: "14px" }}>
                            <translation-container context={this} value="Selected Interactions:" /> {this.interactionCount}
                        </div>
                    </v-expansion-panel-header>
                    
                    <v-expansion-panel-content>
                        <div>
                            { this.getInteractionDetails() }

                            <div class="mb-4">
                                <div class="text-caption font-weight-bold" style={{ color: 'rgba(0,0,0,0.6) !important' }}><translation-container context={this} value={`Date & Time ${this.interactionCount == 1 ? "" : "Range"}`} /></div>
                                <div style={{ fontSize: '14px' }}>{this.formattedDateRange || "N/A"}</div>
                            </div>

                            <div>
                                <div class="text-caption font-weight-bold" style={{ color: 'rgba(0,0,0,0.6) !important' }}><translation-container context={this} value="Queues" /></div>
                                <div style={{ fontSize: '14px' }}>{this.queues.join(', ') || 'None'}</div>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        );

        if (!this.conversationStarted) {
            var errorText = null;
            if (this.analysisDisabled) {
                // warning based on interaction selection count
                if (this.interactionCount > 0) {
                    errorText = (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '8px', color: 'var(--v-error-base)' }}>
                            <translation-container context={this} value={`Too many interactions for analysis with ${this.useTranscripts ? "transcripts" : "summaries"}`} />
                        </div>
                    );
                } else {
                    errorText = (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '8px', color: 'var(--v-error-base)' }}>
                            <translation-container context={this} value={`No interactions provided for analysis`} />
                        </div>
                    );
                }
            }

            content = (
                <v-card class="AskAI" style="height: 100%; display: flex; flex-direction: column;">
                    <v-card-title style="padding-bottom: 16px;">
                        <span><translation-container context={this} value={this.action.ActionData.Name || 'Ask AI'} /></span>
                        <v-spacer />
                        <v-btn icon small on-click={this.finish}>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text style="flex: 1; overflow-y: auto;">
                        {expansionSection}

                        <div class="mb-6">
                            <div class="text-primary text-subtitle-1 mb-6" style={{ color: "rgba(0,0,0,0.87)" }}><translation-container context={this} value="Choose analysis source" />:</div>
                            
                            <v-radio-group vModel={this.useTranscripts} row class="mt-0 mb-4 pt-0 align-radio-top">
                                <div class="d-flex align-start">
                                
                                <div style={{ height: '100%', position: 'relative' }}>
                                    <v-radio value={false} class="AskAiRadioInput mt-0" style={{ alignItems: 'flex-start', margin: '0px' }}>
                                        <div slot="label" class="ml-2 mt-2">
                                            <div class="text--primary mb-1"><translation-container context={this} value="Summaries" /></div>
                                            <div class="text--secondary" style={{ fontSize: "14px" }}>
                                                <translation-container context={this} value="Faster results based on AI-generated interaction summaries." />
                                            </div>
                                            <div class="text--secondary mb-2" style={{ fontSize: "14px" }}>
                                                <translation-container context={this} value="Best for trends and high-level insights." />
                                            </div>
                                        </div>
                                    </v-radio>

                                    <div class="success--text font-weight-medium" style={{ fontSize: "14px", position: 'absolute', bottom: -20, left: 40 }}>
                                        <translation-container context={this} value="Analyze 100 interactions." />
                                    </div>
                                </div>

                                <v-divider vertical class="mx-4" style="height: auto; align-self: stretch;" />

                                <div style={{ height: '100%', position: 'relative' }}>
                                    <v-radio value={true} class="AskAiRadioInput mt-0" style={{ alignItems: 'flex-start', margin: '0px' }}>
                                        <div slot="label" class="ml-2 mt-2">
                                            <div class="text--primary mb-1">Transcripts</div>
                                            <div class="text--secondary" style={{ fontSize: "14px" }}>
                                                <translation-container context={this} value="More detailed and precise analysis based on full interaction transcripts." />
                                            </div>
                                            <div class="text--secondary mb-2" style={{ fontSize: "14px" }}>
                                                <translation-container context={this} value="Best for deep investigation." />
                                            </div>
                                        </div>
                                    </v-radio>

                                    <div class="orange--text text--darken-2 font-weight-medium" style={{ fontSize: "14px", position: 'absolute', bottom: -20, left: 40 }}>
                                        <translation-container context={this} value="Analyze 30 interactions." />
                                    </div>
                                </div>
                                
                                </div>
                            </v-radio-group>
                        </div>

                        <v-btn color="primary" block on-click={this.startAnalysis} disabled={this.analysisDisabled}>
                            <translation-container context={this} value="Start Analysis" />
                        </v-btn>

                        {errorText}
                    </v-card-text>
                </v-card>
            );
        } else {
            content = (
                <v-card class="AskAI" style="height: 100%; display: flex; flex-direction: column;">
                    <v-card-title>
                        <span><translation-container context={this} value={this.action.ActionData.Name || 'Ask AI'} /></span>
                        <v-spacer />
                        <v-btn icon small on-click={this.handleExit}>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
                        {expansionSection}

                        <div style={{ display: 'flex', 'flexDirection': 'row', justifyContent: 'space-between' }}>
                            <div style={{ color: "rgba(0,0,0,0.87)", textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                                <translation-container context={this} value={`Analysis based on interaction ${this.useTranscripts ? "transcripts" : "summaries"}` } />
                            </div>

                            <div>
                                <v-btn outlined color="primary" class="ml-2" on-click={this.export}>
                                    <translation-container context={this} value="Export" />
                                </v-btn>
                            </div>
                        </div>

                        <div class="chat-messages-container">
                            {this.messages.map((msg, idx) => (
                                <div key={idx} class={`chat-message-wrapper ${msg.role === 'user' ? 'chat-message-user' : 'chat-message-assistant'}`}>
                                    <div class="chat-message-bubble" domPropsInnerHTML={this.getMarkdownHtml(msg.content)}></div>
                                </div>
                            ))}
                            {this.loading && (
                                <div class="text-center">
                                    <v-progress-circular indeterminate color="primary" />
                                </div>
                            )}
                        </div>

                        <v-textarea
                            vModel={this.userInput}
                            placeholder="Write your message..."
                            outlined
                            dense
                            hide-details
                            auto-grow
                            rows="1"
                            class="AskAiInput"
                            on-keyup={this.keyUp}
                        >
                            <v-btn
                                slot="append"
                                color="primary"
                                icon
                                on-click={this.sendMessage}
                                disabled={!this.userInput.trim() || this.loading}
                            >
                                <v-icon>mdi-send</v-icon>
                            </v-btn>
                        </v-textarea>
                    </v-card-text>

                    <v-dialog vModel={this.showExitConfirm} max-width="400">
                        <v-card on-closeme={() => this.showExitConfirm = false}>
                            <v-app-bar flat color="rgba(0, 0, 0, 0)" style={{ backgroundColor: 'var(--v-navigation-base)', maxHeight: '60px', height: '60px' }}>
                                <v-toolbar-title class="title white--text pl-0">
                                    <translation-container context={this} value="End Conversation?" />
                                </v-toolbar-title>

                                <v-spacer></v-spacer>

                                <v-btn elevation={0} color="white" icon on-click={(e) => this.showExitConfirm = false}>
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-app-bar>

                            <v-card-text class="mt-2">
                                <translation-container context={this} value="Are you sure you want to end this conversation? These conversations are not saved." />
                            </v-card-text>

                            <v-card-actions style="justify-content: flex-end;">
                                <v-btn color="primary" elevation={0} on-click={this.confirmExit}>
                                    <translation-container context={this} value="Confirm" />
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
            );
        }

        return content;
    }
});